import type { Prismic } from '@landsbankinn/prismic';
import {
  fallbackText,
  getDataFromLink,
  PrismicLink,
} from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { IconLink } from '../components/button/IconLink';
import { Shortcuts } from '../components/shortcuts/Shortcuts';

interface IProps {
  fields: IField[];
}

interface IField {
  icon: string;
  link: Prismic.Link;
  link_text: Prismic.RichText;
}

export const ShortcutsContainer = ({ fields }: IProps) => {
  return (
    <Segment paddingTop={0} paddingBottom={0}>
      <Shortcuts>
        {fields?.length &&
          fields.map(({ icon, link, link_text }, index) => {
            const linkdata = getDataFromLink(link);
            const title = fallbackText(link_text, linkdata.title ?? undefined);
            return (
              <PrismicLink
                key={`${index}-${icon}`}
                value={link}
                title={title ?? undefined}
              >
                <IconLink text={title} icon={icon} />
              </PrismicLink>
            );
          })}
      </Shortcuts>
    </Segment>
  );
};
